import React from 'react';
import { PropTypes } from 'prop-types';
import { Button, ButtonGroup } from 'reactstrap';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const KEY = 'size';
const WIDE = 'wide';
const NARROW = 'narrow';

const ListSize = ({ onDataChange, size }) => {
  const wideSelected = size === WIDE.toLowerCase() ? 'selected-option' : '';
  const narrowSelected = size === NARROW ? 'selected-option' : '';

  return (
    <div className="row config-container align-items-center">
      <div className="config-title mr-3">
        List size
      </div>
      <ButtonGroup className="options-list">
        <Button className={`option-title ${wideSelected} text-uppercase`} onClick={() => { onDataChange(KEY, WIDE); }}>
          <FontAwesomeIcon icon="expand" />
          {`${WIDE}`}
        </Button>
        <Button className={`option-title  ${narrowSelected} text-uppercase`} onClick={() => { onDataChange(KEY, NARROW); }}>
          <FontAwesomeIcon icon="compress" />
          {`${NARROW}`}
        </Button>
      </ButtonGroup>
    </div>
  );
};

ListSize.propTypes = {
  onDataChange: PropTypes.func,
  size: PropTypes.string
};

ListSize.defaultProps = {
  onDataChange: () => { },
  size: ''
};

export default ListSize;



// WEBPACK FOOTER //
// ./src/components/dashboard/list/configuration-elements/ListSize.js